module.exports = __webpack_public_path__ + "img/checked.ea986b81.svg";